/**
 * adminLicenseFilters — 21/09/2026 (demande user : « ne plus montrer les
 * licences expirées ou désactivées, filtrer par date de fin ou de
 * création »). Logique pure, consommée par AdminPanel/LicensesTab.
 */

export const LICENSE_STATUSES = ['active', 'expired', 'disabled'];

export const DEFAULT_LICENSE_FILTERS = {
  statuses: ['active'],
  createdFrom: '',
  createdTo: '',
  expiresFrom: '',
  expiresTo: '',
};

export const DEFAULT_LICENSE_SORT = { key: 'created_at', dir: 'desc' };

export const LICENSE_SORT_OPTIONS = [
  { value: 'created_at:desc', label: 'Création (récentes d\'abord)' },
  { value: 'created_at:asc', label: 'Création (anciennes d\'abord)' },
  { value: 'expires_at:asc', label: 'Expiration (proches d\'abord)' },
  { value: 'expires_at:desc', label: 'Expiration (lointaines d\'abord)' },
  { value: 'holder_name:asc', label: 'Titulaire (A → Z)' },
  { value: 'holder_name:desc', label: 'Titulaire (Z → A)' },
];

export function getLicenseStatus(lic, now = new Date()) {
  if (!lic.is_active) return 'disabled';
  if (lic.expires_at && new Date(lic.expires_at) < now) return 'expired';
  return 'active';
}

const dayStart = (iso) => (iso ? new Date(`${iso}T00:00:00`) : null);
const dayEnd = (iso) => (iso ? new Date(`${iso}T23:59:59.999`) : null);

function inRange(value, fromIso, toIso) {
  if (!fromIso && !toIso) return true;
  if (!value) return false;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return false;
  const from = dayStart(fromIso);
  const to = dayEnd(toIso);
  if (from && d < from) return false;
  if (to && d > to) return false;
  return true;
}

export function filterLicenses(list, filters = DEFAULT_LICENSE_FILTERS, now = new Date()) {
  const statuses = filters.statuses || [];
  return (list || []).filter((lic) => {
    if (statuses.length > 0 && !statuses.includes(getLicenseStatus(lic, now))) return false;
    if (!inRange(lic.created_at, filters.createdFrom, filters.createdTo)) return false;
    if (!inRange(lic.expires_at, filters.expiresFrom, filters.expiresTo)) return false;
    return true;
  });
}

export function sortLicenses(list, sort = DEFAULT_LICENSE_SORT) {
  const { key, dir } = sort;
  const sign = dir === 'asc' ? 1 : -1;
  return [...(list || [])].sort((a, b) => {
    if (key === 'holder_name') {
      return sign * (a.holder_name || '').localeCompare(b.holder_name || '', 'fr', { sensitivity: 'base' });
    }
    const ta = a[key] ? new Date(a[key]).getTime() : NaN;
    const tb = b[key] ? new Date(b[key]).getTime() : NaN;
    const aMissing = Number.isNaN(ta);
    const bMissing = Number.isNaN(tb);
    if (aMissing && bMissing) return 0;
    if (aMissing) return 1;
    if (bMissing) return -1;
    return sign * (ta - tb);
  });
}

export function countByStatus(list, now = new Date()) {
  const counts = { active: 0, expired: 0, disabled: 0 };
  (list || []).forEach((lic) => { counts[getLicenseStatus(lic, now)] += 1; });
  return counts;
}

export function countActiveFilters(filters) {
  let n = 0;
  const statuses = filters.statuses || [];
  if (statuses.length > 0 && statuses.length < LICENSE_STATUSES.length) n += 1;
  ['createdFrom', 'createdTo', 'expiresFrom', 'expiresTo'].forEach((k) => { if (filters[k]) n += 1; });
  return n;
}

export function parseSortValue(value) {
  const [key, dir] = String(value || '').split(':');
  return { key: key || DEFAULT_LICENSE_SORT.key, dir: dir === 'asc' ? 'asc' : 'desc' };
}
